import React from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import styles from '../Calculator.module.css';

interface StepTechnologiesProps {
    value: string;
    onChange: (value: string) => void;
}

const StepTechnologies: React.FC<StepTechnologiesProps> = ({ value, onChange }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.step}>
            <div className={styles.header}>
                <h3 className={styles.title}>{t('calculator.technologies.title')}</h3>
                <p className={styles.subtitle}>{t('calculator.technologies.subtitle')}</p>
            </div>
            <div className={styles.technologiesTextareaContainer}>
                <textarea
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    className={styles.technologiesTextarea}
                    placeholder={t('calculator.technologies.placeholder')}
                    rows={6}
                />
            </div>
        </div>
    );
};

export default StepTechnologies;
